export default __webpack_public_path__ + "static/media/imogen_poots1.d773eaee.jpeg";